module.exports = "/assets/landing-bfw/we-offer/decorator.png?9BpMBxm";